export default __webpack_public_path__ + "static/media/img5.b4cd0064.png";